export const ROOT_API_ROUTES = {
  CREATE_SUBSCRIPTION: '/api/subscription',
  CREATE_CUSTOMER_PORTAL: '/api/create-customer-portal-session',
  PLANS: '/api/plans',
  CUSTOMER: '/api/subscriber',
  CARD: '/api/card',
  CANCEL_SUBSCRIPTION: '/api/subscription-cancel',
};
